import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class InternalOnlyGuard  {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.auth.isClientUser()) {
      this.router.navigate([this.auth.getPortalHomeRoute()]);
      return false;
    }
    return true;
  }
}
